export default "__VITE_ASSET__D_s5X$Yu__"